import React, { Fragment, useState, useEffect } from 'react';
import { Card, CardBody, Button } from 'reactstrap';

import { Separator } from '../../../../../components/common/CustomBootstrap';
import { NudgesForm } from './NudgesForm';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { putAPI_Update_Response, putAPI_Update_NudgesButton } from '../../../../../constants/APIs';
import Validation from '../../../../../components/Validation';
export default function NudgesSetting({ integration,showVoucherList, nudges }) {
  // console.log('nudges', nudges);
  const [isUpdating, setIsUpdating] = useState(false);
  const [nudgesData, setNudges] = useState([]);
  const [nudgeData, setNudge] = useState({});
  const [open,setOpen] = useState(false);
  const [msg,setMsg] =useState([]);
  const [nudgeIndex, setNudgeIndex] = useState(0);
  useEffect(() => {
    setNudges(nudges);
  }, []);

  const edit = (data, index) => {
    setNudge(data);
    setNudgeIndex(index)
    setIsUpdating(true)
  }
  const handleSubmit = (eyeCatcherData, data) => {
    // console.log(eyeCatcherData);
    try {
      AxiosAPI({
        method: 'put',
        url: putAPI_Update_Response,
        data: eyeCatcherData,
      })
        .then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
          AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_NudgesButton}/${integration.id}?group_id=${getGroupID()}`,
            data: data,
          })
            .then((json) => {
              if (json.data.HttpStatusCode !== undefined && json.data.HttpStatusCode === 400 && json.data.Messages !== undefined
                && json.data.Messages !== null && json.data.Messages.length > 0) {
                setMsg(json.data.Messages);
                setOpen(true);
              }
              else {
              nudgesData.forEach(n => {
                if (n.eyeCatcher != undefined) {
                  if (n.eyeCatcher.query.code == eyeCatcherData.Code) {
                    n.eyeCatcher.response.messages = eyeCatcherData.Default;
                    n.delayInMilliseconds = data.delayInMilliseconds
                    n.buttons = data.buttons
                  }
                }
              });

              setNudges(nudgesData);
              setIsUpdating(false)
            }
          });
        }      
        });
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Card className="mb-4">
      <CardBody>
        <h6 className="text-center">Nudges</h6>
        <Separator className="mb-3" />
        {nudgesData && nudgesData.map((nudge, index) => {
          return (
            <Fragment key={index}>
              <div className="text-center" style={{ marginTop: '25px' }}>
                {/* <b>Greeting</b>
                <p className="mb-2">
                  {nudge.greeting ? nudge.greeting.response.messages[0] : null}
                </p> */}
                <b>Eye Catcher</b>
                <p className="mb-2">
                  {nudge.eyeCatcher
                    ? nudge.eyeCatcher.response.messages[0]
                    : null}
                </p>
                <b>Delay in Seconds</b>
                <p className="mb-2">
                  {nudge.delayInMilliseconds
                    ? nudge.delayInMilliseconds / 1000
                    : null}
                  s
                </p>
                <Button
                  size="xs"
                  color="success"
                  outline
                  style={{ marginTop: '3px' }}
                  onClick={() => edit(nudge, index)}
                >
                  Edit
                </Button>
              </div>
            </Fragment>
          );
        })}
      </CardBody>
      {isUpdating && (
        <NudgesForm
          formLabel="Update Nudges"
          visible={isUpdating}
          toggle={() => {
            setIsUpdating(!isUpdating);
          }}
          submit={handleSubmit}
          showVoucherList={showVoucherList}
          nudgeData={nudgeData}
          nudgeIndex={nudgeIndex}
        />)}
     <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
    </Card>
  );
}
